<template lang="pug">
  .settings(v-if='settings')
    span
      | {{ $i18n.t('trainer.trainer_gameFormSetting_sequenceOfNumbersMode') }}:
      | {{ gameMode }}
    br
    span
      | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}:
      | {{ tableSize }}
    br
    span(v-if="!settings.countingCombinations")
      | {{ titleForNumOfExamples }}:
      | {{ settings.numOfExamples }}
    br(v-if="!settings.countingCombinations")
    span
      | {{ $i18n.t('trainer.trainer_gameFormSetting_location') }}:
      span(v-if="settings.location.vertically") {{ ' ' + $i18n.t('trainer.trainer_gameFormSetting_location-vertically') }}
      span(v-if="settings.location.horizontally") {{ ' ' + $i18n.t('trainer.trainer_gameFormSetting_location-horizontally') }}
      span(v-if="settings.location.diagonally") {{ ' ' + $i18n.t('trainer.trainer_gameFormSetting_location-diagonally') }}
    br
    span
      | {{titleForCrossingSettings}}:
      | {{ checkIsSettingsOn(settings.crossing) }}
    br
    span
      | {{ titleForDigitCapacitySettings }}:
      | {{ digitCapacityMode }}
    br
    span(v-if="!checkIsNumberGameMode")
      | {{ $i18n.t('trainer.trainer_gameFormSetting_counting-combinations') }}:
      | {{ checkIsSettingsOn(settings.countingCombinations) }}
    br(v-if="!checkIsNumberGameMode")
    span
      | {{ titleForIsColoredSettings }}
      | {{ checkIsSettingsOn(settings.coloredNumbers) }}
    br
    slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import SequenceOfNumbersConfig from '../../trainer/configs/SequenceOfNumbersConfig';

    const NUMBERS_GAME_MODE = 'numbers';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        data() {
            return {
                digitCapacityModes: SequenceOfNumbersConfig.getDigitCapacityModes(),
            };
        },
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            withIcon: Boolean,
        },
        methods: {
            checkIsSettingsOn(settingValue) {
                return settingValue
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_on')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_off');
            },
        },
        computed: {
            digitCapacityMode() {
                return this.digitCapacityModesWithLabel.find(
                    digitCapacityMode => digitCapacityMode.value === +this.settings.digitCapacity
                ).label;
            },
            gameMode() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_sequenceOfNumbersModeNumbers')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_sequenceOfNumbersModeCharacters');
            },
            tableSize() {
                return this.settings.tableSize + ' x ' + this.settings.tableSize;
            },
            titleForNumOfExamples() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_amountOfNumbers')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_amountOfCombination');
            },
            titleForCrossingSettings() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_crossing-numbers')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_crossing-characters');
            },
            titleForDigitCapacitySettings() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_difficulty')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_numOfCharacters');
            },
            titleForIsColoredSettings() {
                return this.checkIsNumberGameMode
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_coloredNumbers')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_coloredCharacters');
            },
            digitCapacityModesWithLabel() {
                return this.digitCapacityModes.map(mode => {
                    mode.label = this.checkIsNumberGameMode ? mode.labelForNumbersMode : mode.labelForCharactersMode;
                    return mode;
                });
            },
            checkIsNumberGameMode() {
                return this.settings.mode === NUMBERS_GAME_MODE;
            },
        },
    };
</script>
